module.exports = __webpack_public_path__ + "static/media/star-off.c763e180.svg";